import React from 'react';

import PropTypes from 'prop-types';

import {Icon} from '@blueprintjs/core';

export default function DefaultHeadRenderer({ head, sort, setSort }) {
  const {
    sortable,
    visible,
    field,
    label,
    defaultSortOrder,
  } = head;
  const isSortField = sortable && field === sort.field;
  const sortOrder = isSortField ? sort.order : defaultSortOrder || 'asc';
  const sortIcon = sortOrder === 'asc'
    ? <Icon icon="sort-asc" />
    : <Icon icon="sort-desc" />;

  let sortOrderNext;

  if (isSortField) {
    sortOrderNext = sort.order === 'asc' ? 'desc' : 'asc';
  } else {
    sortOrderNext = defaultSortOrder || 'asc';
  }

  let className = sortable ? 'DynamicTableData__SortableHeader' : '';
  className += ` DynamicTableData__Header__${(label || '').replace(' ', '_')}`;

  return (
    <th
      key={label + visible}
      className={className}
      onClick={() => {
        if (sortable) {
          setSort((sortOrderNext === 'asc' ? '' : '-') + head.field);
        }
      }}
    >
      {label}
      {isSortField && ' '}
      {isSortField && sortIcon}
    </th>
  );
}

DefaultHeadRenderer.propTypes = {
  sort: PropTypes.shape({
    field: PropTypes.string,
    order: PropTypes.string,
  }).isRequired,
  setSort: PropTypes.func.isRequired,
  head: PropTypes.shape().isRequired,
};